// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__UT5XU"};